import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

    render() {
        const reportData = this.props.reportData;
        const data = this.props.searchData;
        const totalAmount = this.props.totalAmount;

        return (
            <div align='center' style={{ padding: '15px', width: '100rem' }}>
                <h3><center><u>Uncompleted GRN Report</u></center></h3>
                <div >&nbsp;</div>
                <Box minWidth={1150}>
                    <TableContainer>
                        <Table aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">FCC</TableCell>
                                    <TableCell align="left">Date</TableCell>
                                    <TableCell align="left">Supplier Code - Agrithmics</TableCell>
                                    <TableCell align='left'>NIC/BRN</TableCell>
                                    <TableCell align="left">Supplier Preferred Name</TableCell>
                                    <TableCell align="right">GRN Amount (Rs)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row) => {
                                    return (
                                        <TableRow key={row.farmerID}>
                                            <TableCell align="left">{row.factoryName}</TableCell>
                                            <TableCell align="left">{moment(row.date).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell align="left">{row.farmerCode == null ? '-' : row.farmerCode}</TableCell>
                                            <TableCell align='left'>{row.nic}</TableCell>
                                            <TableCell align="left">{row.givenName == null ? '-' : row.givenName}</TableCell>
                                            <TableCell align="right">{parseFloat(row.grnAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}><b>Total</b></TableCell>
                                    <TableCell colSpan={4} />
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}><b>{parseFloat(totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}
